/**
 * Reports API slice (message/conversation reporting).
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth, ApiError } from './client';

export const reportsApi = {
  submit: async ({ messageId, conversationId, reason, message }) => {
    const data = await fetchWithAuth('/json/report', {
      method: 'POST',
      body: {
        messageId,
        conversationId,
        reason,
        message: message?.trim()
      }
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to submit report', 400, data);
    }

    return data;
  }
};
